"use strict";

/**
 * @file
 * RESOURCES LIGHTBOX
 * - Allow lightbox videos to display on fullscreen.
 * - Resize the lightbox video thumbnail to fit the "/resources" page style.
 */

(function ($, Drupal) {
  /**
   * Function to get the height of core Image and apply to Lightbox thumbnails
   */
  function updateLightboxHeight() {
    var imageHeight = $('article.node--view-mode--teaser .media__image').height();
    var $vidyardImage = $('article.node--view-mode--teaser .media img.vidyard-player-embed');
    $vidyardImage.css('height', imageHeight + 'px');
  }

  /**
   * Pivot function to update the height of Lightbox thumbnails
   */
  function setLightboxHeight() {
    var path = window.location.pathname;

    // Check if the path matches "/resources"
    if (path === '/resources') {
      $(window).on('load', function () {
        updateLightboxHeight();
      });
      $(window).resize(function () {
        if (document.documentElement.clientWidth <= 1024) {
          updateLightboxHeight();
        }
      }).resize();
      $(document).ajaxStop(function () {
        updateLightboxHeight();
      });
    }
  }
  Drupal.behaviors.resourcesLightbox = {
    attach: function attach() {
      setLightboxHeight();
    }
  };
})(jQuery, Drupal);
function loadResourceLightbox(vidyarid) {
  jQuery("#resources-lightbox-iframe").html('<iframe allow="autoplay; fullscreen; picture-in-picture; camera; microphone; display-capture" allowfullscreen="" allowtransparency="true" referrerpolicy="no-referrer-when-downgrade" class="vidyard-iframe-' + vidyarid + '" frameborder="0" height="100%" width="100%" scrolling="no" src="https://play.vidyard.com/' + vidyarid + '?disable_popouts=1&amp;v=4.3.10&amp;type=lightbox&amp;autoplay=1" title="" style="opacity: 1; background-color: transparent;"></iframe>');
  jQuery("#resources-lightbox-video").css("display", "flex");
}
jQuery("#resources-lightbox-video-close").click(function () {
  jQuery("#resources-lightbox-iframe").html("");
  jQuery("#resources-lightbox-video").css("display", "none");
});